import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ COMPANY REGISTRY (government corporate-registry relay: Companies House
 * UK, DINUM FR, Zefix CH). Routed by X-INTENT "CompanySearch"/"CompanyProfile"
 * - Doorman.cs sends these straight to the Registry Lambda(s), never touching
 * nrgCore/SQL. Only countries wmos_registry actually supports - DE has no
 * working registry adapter yet, callers must not offer it here.
 */
export const REGISTRY_SUPPORTED_COUNTRIES = ["GB", "FR", "CH"];

/**
 * Free-text company name search. Always resolves to a list (possibly empty)
 * - the caller decides what to do with 0 / 1 / many results, this never
 * throws for "no matches found".
 */
export const searchCompanies = async (query, countryCode, config) => {
    const rawData = await dbPayload(
        "/api/v1/registry/company-search",
        "POST",
        config.siteKey,
        { action: "CompanySearch", payload: { countryCode, query } },
        "CompanySearch"
    );

    if (!rawData?.success) {
        throw new Error(rawData?.message || "Company registry search failed.");
    }

    return rawData.data?.results || [];
};

/**
 * Direct lookup by registry-specific company ID (UK company number, FR
 * SIREN, CH ehraid). Returns null if not found rather than throwing - a
 * miss is a normal outcome here, not an error.
 */
export const getCompanyProfile = async (companyId, countryCode, config) => {
    const rawData = await dbPayload(
        "/api/v1/registry/company-profile",
        "POST",
        config.siteKey,
        { action: "CompanyProfile", payload: { countryCode, companyId } },
        "CompanyProfile"
    );

    if (!rawData?.success) {
        throw new Error(rawData?.message || "Company registry lookup failed.");
    }

    if (!rawData.data?.found) {
        return null;
    }

    return { companyId: rawData.data.companyId, ...rawData.data.company };
};

/**
 * Maps a normalised CompanyProfile.registeredAddress (from wmos_registry) to
 * this form's address field names. Registry data is government-sourced, so
 * once used it does NOT need a follow-up Dogma/Google address validation -
 * that step stays reserved for the manual-entry fallback path only.
 */
export const mapRegistryAddress = (profile) => {
    const address = profile?.registeredAddress || {};
    return {
        addressLine1: address.line1 || "",
        addressLine2: address.line2 || "",
        town: address.city || "",
        county: address.region || "",
        postcode: address.postcode || "",
    };
};
